import { AnimatePresence, motion } from 'framer-motion';
import useMeasure from 'react-use-measure';

const ignoreCircularReferences = () => {
  const seen = new WeakSet();
  return (key: any, value: any) => {
    if (key.startsWith('_')) return; // Don't compare React's internal props.
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) return;
      seen.add(value);
    }
    return value;
  };
};

export default function AnimateHeight({
  open,
  children,
  className,
  duration,
  initial,
}: {
  open: boolean;
  children: any;
  className?: string;
  duration?: number;
  initial?: boolean;
}) {
  const [ref, { height }] = useMeasure();

  return (
    <motion.div
      animate={{
        height: height || 'auto',
        // opacity: 1,
      }}
      transition={{
        // type: 'tween',
        // ease: 'easeOut',
        duration: 0.1,
      }}
    >
      <AnimatePresence mode="popLayout">
        <motion.div
          key={JSON.stringify(children, ignoreCircularReferences())}
          className={className}
          animate={{
            opacity: 1,
          }}
          exit={{
            // height: 0,
            opacity: 0,
          }}
          initial={{
            // height: 0,
            opacity: 0,
          }}
        >
          <div ref={ref} className={`!box-border !p-0`}>
            {children}
          </div>
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
}
